import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import * as React from 'react';
import { STATUS_OPTIONS } from '../hooks/useStatusFilter';

export default function StatusFilterChips({
  selectedStatuses,
  statusCounts,
  onToggleStatus
}) {
  return (
    <Box sx={{ mb: 2 }}>
      <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap>
        <Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.875rem' }}>
          Filtros:
        </Typography>
        {STATUS_OPTIONS.map((option) => {
          const count = statusCounts[option.value] || 0;
          const isSelected = selectedStatuses.includes(option.value);

          // Não mostrar chips para status sem trips
          if (count === 0) return null;

          return (
            <Chip
              key={option.value}
              label={option.label}
              variant={"outlined"}
              color={isSelected ? option.color : "default"}
              size="small"
              clickable
              onClick={() => onToggleStatus(option.value)}
              sx={{
                fontSize: '0.8rem',
                height: '28px',
                '&:hover': {
                  backgroundColor: isSelected
                    ? undefined // Manter cor original quando selecionado
                    : 'action.hover'
                },
                ...(isSelected && {
                  '&.MuiChip-filled': {
                    color: 'white'
                  }
                })
              }}
            />
          );
        })}
      </Stack>
    </Box>
  );
} 